import React from 'react'
import InviteUserWizard from 'components/InviteUserWizard'
import Modal from 'components/shared/Modal'

import './style.styl'

const InviteUserWizardModal = ({ onClose }) => (
  <Modal
    onRequestClose={onClose}
    isOpen={true}
    style={ { content: { padding: 0, border: '1px solid transparent', background: 'none' }} }
  >
    <div className="invite-user-wizard-modal">
      <InviteUserWizard
        successCtaCopy="View Team List"
        onClose={onClose}
      />
    </div>
  </Modal>
)

export default InviteUserWizardModal


// WEBPACK FOOTER //
// ./src/scripts/components/InviteUserWizardModal/index.js